import { IPermission } from "@miplatform/types";

export const hasAnyDependentPermissions = (
  permission: IPermission,
  assignedPermissions: string[]
): boolean => {
  const dependentOnPermissions = permission.dependentOnPermissions || [];

  if (dependentOnPermissions.length === 0) {
    return true;
  }

  return dependentOnPermissions.some((dependentPermissionName) =>
    assignedPermissions.some(
      (assignedPermission) => assignedPermission === dependentPermissionName
    )
  );
};
